import React, { useCallback } from 'react';
import PropTypes from "prop-types";
import {
    AdvancedMarker,
    AdvancedMarkerAnchorPoint,
    useAdvancedMarkerRef
} from '@vis.gl/react-google-maps';
import { Gaz } from 'components/CustomIcon/CustomIcon';
import { Electricity } from 'components/CustomIcon/CustomIcon';
import { Water } from 'components/CustomIcon/CustomIcon';
import { Fuel } from 'components/CustomIcon/CustomIcon';
import { Heat } from 'components/CustomIcon/CustomIcon';
import { Cold } from 'components/CustomIcon/CustomIcon';
import { Wood } from 'components/CustomIcon/CustomIcon';
import { Propane } from 'components/CustomIcon/CustomIcon';

export default function FeatureMarker(props) {
    const {
        position,
        featureId,
        onMarkerClick,
        properties,
        overSiteId,
        activeSiteId,
    } = props;

    const [markerRef, marker] = useAdvancedMarkerRef();
    const handleClick = useCallback(
        () => onMarkerClick && onMarkerClick(marker, featureId),
        [onMarkerClick, marker, featureId]
    );

    return (
        <AdvancedMarker
            ref={markerRef}
            position={position}
            zIndex={0}
            onClick={handleClick}
            anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
            className={'marker feature'}
            style={{background: ((!activeSiteId && overSiteId === featureId) || activeSiteId === featureId) ? '#91C73C' :  '#605f70'}}>

            {
                properties.energy === 'electricity' ? <Electricity style={{ color: "#FFFFFF" }} /> :
                    properties.energy === 'gas' ? <Gaz style={{ color: "#FFFFFF" }} /> :
                    properties.energy === 'water' ? <Water style={{ color: "#FFFFFF" }} /> :
                    properties.energy === 'fuel' ? <Fuel style={{ color: "#FFFFFF" }} /> :
                    properties.energy === 'heat' ? <Heat style={{ color: "#FFFFFF" }} /> :
                    properties.energy === 'cold' ? <Cold style={{ color: "#FFFFFF" }} /> :
                    properties.energy === 'wood' ? <Wood style={{ color: "#FFFFFF" }} /> :
                    properties.energy === 'propane' ? <Propane style={{ color: "#FFFFFF" }} /> : <></>
            }

        </AdvancedMarker>
    );
}

